import {createSelector} from '@reduxjs/toolkit'
import { fullName } from '../../app/utils'

const collectorBeforeStartConfirmationSelector = createSelector(
    [state => state.components, 
    state => state.primaryAgencyApplication.application],
    (components, primaryApplication) => {

        return Object.assign({}, components.collectorBeforeStartConfirmation, {
            businessContactName : primaryApplication?.contactName ?? fullName(primaryApplication?.businessLicenceData?.mainBusinessContact),
            primaryApplicationLicencingSubType : primaryApplication?.licencingSubType,
            businessApplicationId : primaryApplication?.id,
            businessName : primaryApplication?.name ?? primaryApplication?.businessLicenceData?.businessName,
            companyRjscDetails : primaryApplication?.businessLicenceData?.companyRjscDetails,
            companyTrademark : primaryApplication?.businessLicenceData?.companyTrademark
        })
    }
)

export const collectorBeforeStartConfirmationSelect = state => ({
    collectorBeforeStartConfirmation: collectorBeforeStartConfirmationSelector(state)
})